import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

export default function shouldShowResponseActions(
    viewState: MeetingRequestViewState,
    item: MeetingRequestMessageType
): boolean {
    // Show the response editor if the user has not responded and there's a valid request item
    return item && !['Accept', 'Tentative', 'Decline'].includes(viewState.responseType);
}
